export default {
  'menu.system.model-monitor': '模型监控',
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '智能看板',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.cockpit': '智能决策平台',
  'menu.dashboard.sales': '销售管理BI看板',
  'menu.dashboard.finance': '财务管理BI看板',
  'menu.dashboard.finance-receivable': '财务应收看板',
  'menu.dashboard.finance-invoicing': '财务开票BI看板',
  'menu.dashboard.finance-risk': '财务风控BI看板',
  'menu.dashboard.finance-collection': '财务催款BI看板',
  'menu.dashboard.finance-payable': '财务应付看板',
  'menu.dashboard.document': '单证管理BI看板',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.email': '公共邮箱',
  'menu.email.inbox': '收件箱',
  'menu.email.public-inbox': '公共邮箱收件箱',
  'menu.email.finance-inbox': '财务收件箱',
  'menu.email.logistics-inbox': '物流收件箱',
  'menu.email.hr-inbox': 'HR收件箱',
  'menu.email.compose': '写邮件',
  'menu.email.sent': '已发送',
  'menu.email.draft': '草稿箱',
  'menu.email.trash': '垃圾箱',
  'menu.email.settings': '邮箱设置',
  'menu.email.statistics': '邮箱统计',
  'menu.email.sync-status': '邮件同步监控',
  'menu.email.ai-parse-log': 'AI邮箱解析日志',
  'menu.email.ai-batch-test': 'AI批量解析测试',
  'menu.email.feedback-management': 'AI分类反馈管理',
  'menu.email.assignment-config': '邮件分配配置',
  'menu.system': '系统管理',
  'menu.system.role': '角色管理',
  'menu.system.user': '用户管理',
  'menu.system.user-role-assignment': '用户角色分配',
  'menu.system.data-permission-assignment': '数据权限分配',
  'menu.system.function-permission': '功能权限配置',
  'menu.system.node-permission': '节点权限分配',
  'menu.system.menu-management': '菜单管理',
  'menu.system.menu': '菜单管理',
  'menu.system.dept': '部门档案',
  'menu.system.org': '组织档案',
  'menu.system.code': '编码定义',
  'menu.system.print-business-object': '打印业务对象管理',
  'menu.system.print-template': '打印模版配置',
  'menu.system.email-template': '邮件发送模版配置',
  'menu.system.global-params': '全局参数设置',
  'menu.system.operation-log': '操作日志',
  'menu.system.login-log': '登陆日志',
  'menu.system.external-interaction-log': '外系统交互日志',
  'menu.process': '流程管理',
  'menu.process.bill-type': '单据类型',
  'menu.process.transaction-type': '交易类型管理',
  'menu.process.definition': '流程定义',
  'menu.process.approval': '审批中心',
  'menu.process.rules': '流程规则',
  'menu.master-data': '主数据管理',
  'menu.data-center': '数据管理中心',
  'menu.data-center.comparison': '数据比对中心',
  'menu.data-center.product': '产品中心',
  'menu.data-center.code-conversion': '内外码转换中心',
  'menu.data-center.confirmation': '询价确认单',
  'menu.master-data.customer': '客户',
  'menu.master-data.vessel': '船舶档案',
  'menu.master-data.supplier': '供应商',
  'menu.master-data.warehouse': '仓库',
  'menu.master-data.equipment': '设备',
  'menu.master-data.设备': '设备',
  'menu.master-data.equipment-model': '设备型号',
  'menu.master-data.设备型号': '设备型号',
  'menu.master-data.tax-rate': '税率档案',
  'menu.master-data.measurement-unit': '计量单位',
  'menu.master-data.unit-synonym': '单位别名',
  'menu.master-data.country-region': '国家地区',
  'menu.master-data.payment-term': '支付条款',
  'menu.master-data.manufacturer': '制造商',
  'menu.master-data.shipping-terms': '运输条款',
  'menu.master-data.product-quality': '产品品质',
  'menu.master-data.currency': '币种档案',
  'menu.master-data.spare-part': '备件号',
  'menu.master-data.material': '物料档案',
  'menu.master-data.cargo-location': '货位',
  'menu.master-data.code-archive': '编码档案',
  'menu.master-data.bank': '银行档案',
  'menu.master-data.accounting-subject': '会计科目-总账',
  'menu.master-data.logistics-expense-item': '物流费用项目',
  'menu.logistics.shipment-receipt': '签收单',
  'menu.logistics.shipment-notice': '发货通知单',
  'menu.logistics.shipment-delivery': '发货单',
  'menu.report.customer-pending-shipment': '客户待发货清单',
  'menu.master-data.expense-type': '费用类型',
  'menu.master-data.management-fee': '管理费配置',
  'menu.master-data.hscode': 'HS编码',
  'menu.inquiry-quote': '询报价管理',
  'menu.inquiry-quote.purchase-inquiry-confirmation': '客户询价确认单',
  'menu.inquiry-quote.purchase-inquiry': '采购询价单',
  'menu.inquiry-quote.supplier-quotation': '供应商报价单',
  'menu.inquiry-quote.供应商报价表': '供应商报价表',
  'menu.sales': '销售管理',
  'menu.sales.quotation': '销售报价单',
  'menu.sales.order': '销售订单',
  'menu.sales.order-change': '销售订单变更',
  'menu.sales.return': '销售退货',
  'menu.sales.outsourcing': '委外订单',
  'menu.sales.outsourcing.order': '委外订单',
  'menu.sales.outsourcing.outbound': '委外样品出库单',
  'menu.sales.outsourcing.arrival': '委外到货单',
  'menu.sales.outsourcing.inbound': '委外入库单',
  'menu.sales.transfer': '调拨单',
  'menu.sales.transfer.order': '调拨单',
  // tagsview 按路径段构造 `menu.` + path 反查页签名，详情页需命中各自父级名称
  'menu.sales.transfer.order.detail': '调拨单',
  'menu.sales.transfer.outbound': '调拨出库单',
  'menu.sales.transfer.outbound.detail': '调拨出库单',
  'menu.sales.transfer.inbound': '调拨入库单',
  'menu.sales.transfer.inbound.detail': '调拨入库单',
  'menu.warehouse.transfer': '调拨单',
  'menu.invoice-management': '发票管理',
  'menu.general.attendance-center': '考勤中心',
  'menu.general.attendance-center.punch-records': '考勤打卡',
  'menu.general.attendance-center.attendance-summary': '考勤汇总表',
  'menu.general.attendance-device': '考勤设备',
  'menu.general.attendance-device.device-info': '考勤设备信息',
  'menu.invoice-management.sales-invoice': '销售发票',
  'menu.invoice-management.supplier-invoice': '供应商发票',
  'menu.general': '人力资源',
  'menu.general.employee-archive': '员工档案',
  'menu.general.employee-archive.employee-management': '员工管理',
  'menu.general.hr': 'HR管理',
  'menu.general.hr.attendance-summary': '考勤汇总表',
  'menu.general.hr.day-swap': '调休单',
  'menu.general.hr.department-performance-target': '团队年度绩效',
  'menu.general.welfare-management': '福利管理',
  'menu.general.welfare-management.welfare-list': '福利清单',
  'menu.procurement': '采购管理',
  'menu.procurement.purchase-order': '采购订单',
  'menu.procurement.supplier-invoice': '供应商发票',
  'menu.inventory': '库存管理',
  'menu.inventory.inventory-details': '库存明细',
  'menu.inventory.inventory-flow': '库存出入库流水',
  'menu.warehouse': '仓库管理',
  'menu.warehouse.arrival-inspection': '收货单',
  'menu.warehouse.arrival-inspection-scan': '扫码生成',
  'menu.warehouse.receipt-order': '采购入库单',
  'menu.warehouse.pda-scan': 'PDA扫码入库',
  'menu.warehouse.sales-outbound': '销售出库单',
  'menu.warehouse.location-occupancy': '货位占用图',
  'menu.warehouse.other-inbound': '其他入库单',
  'menu.warehouse.other-outbound': '其他出库单',
  'menu.warehouse.consumables': '耗材',
  'menu.warehouse.consumables.consumable-requisition': '耗材领用单',
  'menu.warehouse.consumables.requisition': '耗材领用单',
  'menu.warehouse.customer-entry-notice': '客户进仓单',
  'menu.warehouse.third-party-inbound': '第三方入仓单',
  'menu.logistics': '物流管理',
  'menu.logistics.logistics-quotation': '物流报价单',
  'menu.logistics.logistics-sales-order': '物流销售订单',
  'menu.logistics.shipment': '发货管理',
  'menu.logistics.shipment.notice': '发货通知单',
  'menu.logistics.shipment.delivery': '发货单',
  'menu.logistics.shipment.receipt': '签收单',
  'menu.logistics.customer-entry-notice': '客户进仓单',
  'menu.document': '单证管理',
  'menu.document.trade-export-invoice': '出口发票单',
  'menu.document.invoice-reconciliation': '发票核对单',
  'menu.document.tax-refund': '退税单',
  'menu.document.invoice-reminder': '催票明细表',
  'menu.document.催票明细表': '催票明细表',
  'menu.document.input-vat-invoice': '进项税发票库存',
  'menu.document.进项税发票库存': '进项税发票库存',
  'menu.document.同步配置': '同步配置',
  'menu.document.customs-declaration-self': '报关单(自制)',
  'menu.document.报关单（自制）': '报关单（自制）',
  'menu.document.export-invoice': '出口发票',
  'menu.document.出口发票': '出口发票',
  'menu.finance': '财务管理',
  'menu.finance.daily-expense': '日常费用',
  'menu.finance.payable-management': '应付管理',
  'menu.finance.receivable-management': '应收管理',
  'menu.finance.invoice-management': '发票管理',
  'menu.finance.fixed-asset': '固定资产',
  'menu.finance.fixed-asset-ledger': '固定资产台账',
  'menu.finance.fixed-asset-ledger-new': '新增固定资产',
  'menu.finance.fixed-asset-ledger-detail': '固定资产卡片详情',
  'menu.finance.fixed-asset.ledger': '固定资产台账',
  'menu.finance.sales-prepayment-order': '销售预收单',
  'menu.finance.business-trip-application': '出差申请单',
  'menu.finance.travel-reimbursement': '差旅报销单',
  'menu.finance.差旅报销单': '差旅报销单',
  'menu.finance.出差申请单': '出差申请单',
  'menu.finance.entertainment-expense-application': '业务招待费用申请单',
  'menu.finance.业务招待费用申请单': '业务招待费用申请单',
  'menu.finance.boarding-deposit-application': '登船押金申请单',
  'menu.finance.登船押金申请单': '登船押金申请单',
  'menu.finance.cash-advance-application': '借支申请单',
  'menu.finance.借支申请单': '借支申请单',
  'menu.finance.purchase-prepayment-application': '采购预付申请单',
  'menu.finance.采购预付申请单': '采购预付申请单',
  'menu.finance.customer-management-fee-application': '客户管理费申请单',
  'menu.finance.客户管理费申请单': '客户管理费申请单',
  'menu.finance.payable-order': '应付单',
  'menu.finance.应付单': '应付单',
  'menu.finance.payment-order': '付款单',
  'menu.finance.付款单': '付款单',
  'menu.finance.receivable-order': '应收单',
  'menu.finance.应收单': '应收单',
  'menu.finance.receipt-order': '收款单',
  'menu.finance.收款单': '收款单',
  'menu.cash': '现金管理',
  'menu.现金管理': '现金管理',
  'menu.cash.fund-allocation': '资金调拨',
  'menu.现金管理.资金调拨': '资金调拨',
  'menu.cash.bank-balance-flow': '银行余额流水',
  'menu.现金管理.银行余额流水': '银行余额流水',
  'menu.cash.cash-flow': '现金流量',
  'menu.现金管理.现金流量': '现金流量',
  'menu.cost': '成本管理',
  'menu.cost.expense-registration-ledger': '费用登记台账',
  'menu.rd': '研发管理',
  'menu.rd.new-product-rd': '新品研发',
  'menu.report': '报表中心',
  'menu.report.customer-info-docking': '客户信息对接表',
  'menu.report.procurement-sales-monthly-summary': '采销月度总结表',
  'menu.report.monthly-sales-amount': '月度销售额',
  'menu.report.annual-sales-amount': '年度销售额',
  'menu.report.accounts-receivable-details-summary': '应收明细汇总表',
  'menu.report.cost-analysis': '成本分析表',
  'menu.report.gross-profit': '毛利表',
  'menu.report.daily-inquiry-quotation': '日询报价表',
  'menu.report.sales-details': '销售明细',
  'menu.report.goods-receipt-delivery-details': '收发货明细表',
  'menu.report.inquiry-order-retention': '询价单滞留表',
  'menu.report.quotation-order-retention': '报价单滞留表',
  'menu.report.purchase-order-retention': '采购订单滞留表',
  'menu.report.accounts-payable-details-summary': '应付明细汇总表',
  'menu.report.supplier-aging': '供应商帐龄表',
  'menu.report.customer-aging': '客户帐龄表',
  'menu.report.customer-management-fee-details': '客户管理费明细表',
  'menu.report.supplier-settlement': '供应商结算表',
  // 报表中心中文key（用于路由配置中使用中文name的情况）
  'menu.报表中心': '报表中心',
  'menu.报表中心.应付明细汇总表': '应付明细汇总表',
  'menu.报表中心.供应商帐龄表': '供应商帐龄表',
  'menu.报表中心.客户帐龄表': '客户帐龄表',
  'menu.报表中心.客户管理费明细表': '客户管理费明细表',
  'menu.报表中心.供应商结算表': '供应商结算表',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
